import { Box, type ColorProps, Flex, Heading, type LayoutProps } from '@chakra-ui/react'

import WavyPath from '@/components/Icons/WavyPath'

export default function WavyHeading({
  text,
  width,
  color = 'yellow.solid',
  textColor = 'fg',
}: {
  text: string
  width: LayoutProps['width']
  color?: string
  textColor?: ColorProps['color']
}): JSX.Element {
  return (
    <Flex direction="column" align="center" my="16px">
      <Heading size="xl" as="h3" color={textColor}>
        {text}
      </Heading>
      <Box as="span" width={width} maxWidth="90%" mb="16px">
        <WavyPath color={color} />
      </Box>
    </Flex>
  )
}
